<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

import {MUserInfo} from "./api";

export default {
  name: 'App',
  computed:{
    userInfo:{
      get(){
        return this.$store.state.user.userInfo
      },
      set(val){
        this.$store.commit('updateUserInfo',val)
      }
    }
  },
  mounted(){
    window.addEventListener('beforeunload', this.onBeforeUnload);
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.onBeforeUnload);
  },
  methods:{
    onBeforeUnload(event) {
      // 在这里编写你想在关闭页面前执行的代码
      // 例如：提示用户是否真的想要离开
      // event.preventDefault();
      // event.returnValue = '';
      localStorage.removeItem('verificationToken2Router')
    },
    getInfo(){
      MUserInfo().then(res=>{
        this.userInfo = res.data
      })
    },
  },
  created() {
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))));
    }
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state));
    });
  },
}
</script>

<style>
  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  html,body,#app{
    height: 100%;
  }


#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/
}
  @font-face {
    font-family: 'iconfont';  /* Project id 3367560 */
    src: url('//at.alicdn.com/t/font_3367560_qv4e7zk92of.woff2?t=1652687112001') format('woff2'),
    url('//at.alicdn.com/t/font_3367560_qv4e7zk92of.woff?t=1652687112001') format('woff'),
    url('//at.alicdn.com/t/font_3367560_qv4e7zk92of.ttf?t=1652687112001') format('truetype');
  }
  .iconfont{
    font-family: 'iconfont';
    font-size: 28px;
  }
  .icon-paifangyuan::before{
    content: '\e62f';
  }

   .icon-shujuku::before{
    content: '\e6e1';
  }
  .icon-ditu::before{
    content: '\e696';
  }
  .icon-more::before{
    content: '\e6dd';
  }

  .companyTable{
    color: #7030a0 !important;
  }





</style>
